import PropTypes from 'prop-types'
import {
  Avatar,
  Checkbox,
  FormControlPaper,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from 'core/components/Core'

const CheckboxIcon = ({ icon, labelName }) => {
  return (
    <ListItem style={{ border: 'none' }} disableGutters dense>
      <ListItemAvatar>
        <Avatar variant="rounded">{icon}</Avatar>
      </ListItemAvatar>
      <ListItemText primary={labelName} />
    </ListItem>
  )
}

const CheckboxFormControlPaper = ({ icon, PaperProps, value, checked, labelName, ...props }) => {
  return (
    <FormControlPaper
      PaperProps={{ ...PaperProps, elevation: 0 }}
      value={value}
      checked={checked}
      control={<Checkbox color="primary" />}
      label={icon ? <CheckboxIcon icon={icon} labelName={labelName} /> : labelName}
      {...props}
    />
  )
}

CheckboxIcon.propTypes = {
  icon: PropTypes.element.isRequired,
  labelName: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
}

CheckboxIcon.defaultProps = {
  labelName: '',
}

CheckboxFormControlPaper.propTypes = {
  icon: PropTypes.element,
  PaperProps: PropTypes.object,
  value: PropTypes.string.isRequired,
  checked: PropTypes.any,
  labelName: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
}

CheckboxFormControlPaper.defaultProps = {
  icon: null,
  PaperProps: {},
  labelName: '',
  checked: null,
}

export default Checkbox
export { CheckboxFormControlPaper }
